import type { ReactNode } from 'react';
import clsx from 'clsx';

type Tone = 'neutral' | 'accent' | 'success' | 'warn' | 'danger';

interface Props {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  dot?: boolean;
}

export function Badge({ tone = 'neutral', children, className, dot }: Props) {
  const toneClass =
    tone === 'accent'
      ? 'bg-pb-accent-soft text-pb-accent'
      : tone === 'success'
        ? 'bg-pb-success-soft text-pb-success'
        : tone === 'warn'
          ? 'bg-[color-mix(in_oklab,var(--pb-warn)_14%,transparent)] text-pb-warn'
          : tone === 'danger'
            ? 'bg-[color-mix(in_oklab,var(--pb-danger)_14%,transparent)] text-pb-danger'
            : 'bg-pb-paper2 text-tg-hint';
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-pb-xs px-1.5 py-0.5 text-[11px] font-medium',
        toneClass,
        className,
      )}
    >
      {dot ? (
        <span
          className={clsx(
            'inline-block h-1.5 w-1.5 rounded-full',
            tone === 'success' && 'bg-pb-success',
            tone === 'accent' && 'bg-pb-accent',
            tone === 'warn' && 'bg-pb-warn',
            tone === 'danger' && 'bg-pb-danger',
            tone === 'neutral' && 'bg-tg-hint',
          )}
          aria-hidden
        />
      ) : null}
      {children}
    </span>
  );
}
